export default __webpack_public_path__ + "static/media/happy.7f75f6e0.png";